import { render, staticRenderFns } from "./AttachedDocumentsTreeModal.vue?vue&type=template&id=74f39f53&"
import script from "./AttachedDocumentsTreeModal.vue?vue&type=script&lang=js&"
export * from "./AttachedDocumentsTreeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports